export const generateDelay = (selector: string, size: number, second: number) => {
  return Array.apply(undefined, { length: size })
    .map(Number.call, Number)
    .map((i: number) => {
      if (i > 0) {
        return template(selector, i, second * (i / (size - 1)))
      }
    })
    .join('')
}

const template = (selector: string, index: number, second: number) =>
  `${selector}:nth-child(${index + 1}) {
		animation-delay: ${second}s;
	}`



// WEBPACK FOOTER //
// ./src/styles/generateDelay/index.ts